export default __webpack_public_path__ + "static/media/Bionic-Arm-11.e86cd746.jpg";